import schema from "../../schema/schema.json"

//console.log("SCHEMA", schema.__schema)

export default schema.__schema
